import { Box, Button, Grid, Stack } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { useMemo } from "react";
import * as yup from "yup";

import { TextareaField } from "./form/TextareaField";
import { TextField } from "./form/TextField";

const EWCCodeFormSchema = yup.object().shape({
  code: yup.string().required(),
  product: yup.string().required(),
  note: yup.string(),
});

interface FormValues {
  code: string;
  product: string;
  note: string;
}

interface SubmitValues {
  code: string;
  product: string;
  note: string | null;
}

interface EWCCodeFormProps {
  initialValues?: FormValues;
  onSubmit: (values: SubmitValues) => Promise<void>;
}

export const EWCCodeForm: React.FC<EWCCodeFormProps> = (props) => {
  const initialValues = useMemo(() => {
    if (!props.initialValues) {
      return {
        code: "",
        product: "",
        note: "",
      };
    }

    return props.initialValues;
  }, [props.initialValues]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={EWCCodeFormSchema}
      onSubmit={async (values) => {
        // A blank note is sent as null so clearing the field removes the note
        await props.onSubmit({ ...values, note: values.note.trim() || null });
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <Stack spacing={6}>
            <Grid gridTemplateColumns="auto auto" gridRowGap={6} gap={6}>
              <Box>
                <TextField name="code" label="Code" />
              </Box>
              <Box>
                <TextField name="product" label="Product" />
              </Box>
              <Box gridColumn="1 / -1">
                <TextareaField name="note" label="Note (optional)" />
              </Box>
            </Grid>

            <Box>
              <Button type="submit" colorScheme="blue" disabled={isSubmitting}>
                Submit
              </Button>
            </Box>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};
